import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";



// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import CircularProgress from '@material-ui/core/CircularProgress';

import SpindlApi from "modules/spindl-api";

//TDOD: Before handing over to anyone - Completely reformat this. 
// - Make it a functional component 
// - clean up the inline and all styles
// - use hooks
// - refactor app class to use an api provider

class RateCard extends React.Component {
    state = {
        rateCard:{},
        value: 0,
        editHeader:false

    };
    dirtyFields = {};
    saveField = async (e)=>{
        
        const {value, attributes} = e.target
        const {rateId, field} = attributes;
        //test to see if field was actually changed. If not, just return out of it

        if(this.dirtyFields[rateId.value] && this.dirtyFields[rateId.value][field.value]){
            const data = {}
            data[field.value] = value;
            const response = await SpindlApi.updateRate({rateId:rateId.value, data})
            delete this.dirtyFields[rateId.value][field.value]
        }

    }
    onChangeHandler = (e)=>{
        const {value, attributes} = e.target
        const {rateId, currentValue, field} = attributes;
        this.dirtyFields[rateId.value]={}
        this.dirtyFields[rateId.value][field.value] = true
    }
    onContextMenuHandler = async (e) => {
        
        e.preventDefault();
        const rateId = e.target.attributes.rateId.value;
        const confirmed = window.confirm('Delete this row?');
        if(confirmed){
            try{
                await SpindlApi.deleteRate({rateId:rateId})
                const newRates = this.state.rateCard.rates.filter(function(rate) { 
                    return rate.id !== rateId; 
                });
                const rateCard = this.state.rateCard;
                rateCard.rates = newRates;
            
                this.setState({rateCard:rateCard})
            }catch(e){
                console.error(e);
            }
            
        }

    }
    onAddNewRowClickHandler = async () => {
        const rateCard = this.state.rateCard;
        const newRows = rateCard.rates;
        try{
            const data = {data: {rateCardId:rateCard.id}}
            const newRate = await SpindlApi.createRate(data);
            newRows.push( newRate )
            rateCard.rates = newRows;
            this.setState({rateCard:rateCard})
        }catch(error){
            alert("Unable to create new rate")
            console.error(error)
        }
        
    }
    saveRateCardName = async (e)=>{
        const {rateCardId} = this.props.match.params;
        const {value} = e.target
        const response = await SpindlApi.updateRateCard(
            {
                rateCardId, 
                data: {
                    "cardType":value
                }    
            }
        )
        const rateCard = this.state.rateCard;
        rateCard.cardType = response.cardType
        this.setState(
            {
                editHeader:!this.state.editHeader,
                rateCard:rateCard
            }
        )
    }
    toggleEditHeader = ()=>{
        this.setState(
            {editHeader:!this.state.editHeader}
        )
    }
    async componentDidMount() {

        const {rateCardId} = this.props.match.params;
        const rateCard = await SpindlApi.readRateCardRates({rateCardId});
        rateCard.rates.sort((a,b) => (a.term > b.term) ? 1 : ((b.term > a.term) ? -1 : 0));
        this.setState(
            {rateCard: rateCard}
        )
    }
    render() {
        //Get basic styles?
        const { classes } = this.props;

        const rateCard = this.state.rateCard;
      
        if(!rateCard.cardType){
            return(
                <div style={{margin:"auto", textAlign:"center", marginTop:"calc(50% - 150px)", transform:"translateY(-50%)"}}>
                    <CircularProgress color="secondary" />
                </div>
            )
        }
        
        //Styling for datasheet
        //TODO: Move this to a separate file and refactor to apply correctly
        const dataCellStyle = {
                margin: "0px",
                width:"100%",
                borderWidth:"0px",
                padding:"0px",
                fontSize:"12px",
                textAlign:"right"
                
            }
        const tableSytle = {
            width:"100%",
            borderSpacing:"0px"
        }
        const tdStyle = {
            padding:"0px  5px",
            borderLeft:"#ccc solid 1px",
            borderBottom:"#ccc solid 1px",
            height: "12px"   
        }

        const tdStyleRight = {
            padding:"0px  5px",
            borderLeft:"#ccc solid 1px",
            borderBottom:"#ccc solid 1px",
            height: "12px",
            borderRight : "#ccc solid 1px"
        };
        const thStyle = {
            backgroundColor:"#f8f9fa",
            borderTop:"#ccc solid 1px",
            borderLeft:"#ccc solid 1px",
            borderBottom:"#ccc solid 1px",
        }
        const thRightStyle = {
            backgroundColor:"#f8f9fa",
            border:"#ccc solid 1px",
        }
        const editHeaderStyle = {
            background: "transparent",
            border: "0px",
            color: "#FFFFFF",
            marginTop: "0px",
            minHeight: "auto",
            fontWeight: "300",
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
            marginBottom: "6px",
            textDecoration: "none",
            fontSize: "1.825em",
            lineHeight: "1.5em",
            fontSize: "1.825em",
            borderBottom: "1px white solid",
            padding: "0px"
        }

        //Column headers
        const titles = [
            {
                name:"Term",
                id:"term"
            },
            {
                name: "Min Monthly Return",
                id:"minMonthlyReturn"
            },
            {
                name:"Max Monthly Return",
                id:"maxMonthlyReturn"
            },
            {
                name: "IR",
                id:"regularIR"

            },
            { 
                name: "$10 @ END IR",
                id:"tenAtEndIR"
            }
        ];

        //Build table header row 
        const header = titles.map((title, index)=>{
            return (<th style={(index == titles.length-1)?thRightStyle:thStyle}>{title.name}</th>);
        })

        //TODO: replace this with data return from fetch that will be added to state.
        const rows = this.state.rateCard.rates
        const rowList = rows.map((row)=>{
            const cols = titles.map((title, index)=>{
                let cellStyle = tdStyle;
                if(index==titles.length-1){
                    cellStyle = tdStyleRight;
                }
                return(
                    <td 
                        rateId={row.id} 
                        style = {cellStyle}
                        >
                        <input 
                            style = {dataCellStyle} 
                            type="number" 
                            name={title.id} 
                            rateId={row.id} 
                            onBlur={this.saveField} 
                            onChange={this.onChangeHandler}
                            key={title.id+"_"+row.id} 
                            field={title.id}
                            defaultValue={row[title.id]}
                            currentValue={row[title.id]}
                            />
                    </td>
                )
            })
            return(
                <tr rateId={row.id} onContextMenu={this.onContextMenuHandler}>
                    {cols}
                </tr>
            )
        })
        const tableFooter = (<tr>
                <td style ={{
                        backgroundColor:"rgb(248, 249, 250)",
                        border:"solid 1px #ccc",
                        borderTop:"0px"
                    }}colspan={titles.length}> 
                    <button
                        onClick = {this.onAddNewRowClickHandler} 
                        style={{height:"30px", margin: "10px 15px"}}>
                        Add New Rate
                    </button> 
                </td>
            </tr>)
        const cardHead = (!this.state.editHeader)?(
            <h3 className={classes.cardTitleWhite}> 
                {rateCard.cardType} 
                <span style={{fontSize:14, marginLeft:"7px", cursor:"pointer"}} onClick={this.toggleEditHeader}><Icon style={{fontSize:14}}> 
                    create</Icon>edit
                </span>
            </h3>):<input 
                        autoFocus
                        style = {editHeaderStyle} 
                        defaultValue={rateCard.cardType}
                        type="text"
                        onBlur = {this.saveRateCardName}
                        />
            
        return (
        
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card chart>
                        <CardHeader color="warning" >
                            {cardHead}
                        </CardHeader>
                        <CardBody>
                            <table style={tableSytle}>
                            <thead>
                                {header}
                            </thead>
                            <tbody>
                                {rowList}
                            </tbody>
                            <tfoot>
                                {tableFooter}
                            </tfoot>
                            </table>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
      );
    }
  }
  
  RateCard.propTypes = {
    classes: PropTypes.object.isRequired
  };
  
  export default withStyles(dashboardStyle)(RateCard);
  


// WEBPACK FOOTER //
// ./src/views/RateCard/RateCard.jsx